import type { LocationDescriptorObject } from 'history';
import { UIEvent, Ref } from 'react';

export type LinkBaseProps = {
  children: React.ReactNode;
  onClick?: MouseEvent<HTMLAnchorElement> | UIEvent;
  ref?: Ref<HTMLAnchorElement>;
};

export type LocationDescriptor = LocationDescriptorObject;

export type LinkWithAnchorProps = LinkExternalProps & Pick<LinkProps, 'onClick'>;

export type LinkExternalProps = LinkBaseProps & {
  pathname: string;
};

export type LocationDescriptorWithState = LocationDescriptorObject<StateParams>;

export type LinkProps = LinkBaseProps & {
  exact?: boolean;
  isactive?: boolean;
  onMouseEnter?: React.MouseEventHandler<HTMLAnchorElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLAnchorElement>;
  target?: string;
  title?: string;
  to: LocationDescriptor<StateParams> | string;
};

type StateParams = {
  match?: string;
  pathQueryTitle?: string;
  pathSlug?: string | undefined;
  pathTitle?: string | undefined;
  queryTitle?: string;
  pathname?: string;
};

export type LinkRouterProps = LinkBaseProps & {
  exact?: boolean;
  isactive?: boolean;
  to: LocationDescriptor;
};

export enum LINK_CONST {
  TEST_ID = 'link',
}
